import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Reveal, Eyebrow } from './Section';
const items = ['Querés empezar a trabajar como creadora UGC, aunque todavía no tengas experiencia, clientes, testimonios ni miles de seguidores.', 'Querés trabajar con marcas y cobrar en dólares, pero no sabés cómo crear tus primeros videos, armar tu portfolio ni definir tus servicios.', 'Te frustrás buscando oportunidades en Instagram, sin saber qué marcas contactar, qué mensaje enviarles ni cómo hacer seguimiento.', 'Querés tener en 7 días tu portfolio, tus servicios y un sistema para contactar +80 marcas, y empezar tu camino hacia tus primeros USD 1.000.'];
export function ForWho() {
  return <section className="w-full bg-cream py-16 sm:py-20" data-id="element-75" data-mp="309ksa4isokz2">
      <div className="mx-auto max-w-4xl px-5 sm:px-6" data-id="element-76" data-mp="10xi085w3ui9s">
        <Reveal className="text-center" data-id="element-77" data-mp="10ytdcwbfx2dk">
          <Eyebrow data-id="element-78" data-mp="15wl6turqgwjv">Para quién es</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-plum sm:text-4xl" data-id="element-79" data-mp="15xnwy0h8euyq">
            Este producto es para vos si…
          </h2>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-80" data-mp="skzbgzq5ijma">
          {items.map((item, i) => <Reveal key={item} delay={i * 0.06} data-id="element-81" data-mp="nlmpsib0nila" data-mpi={i}>
              <div className="flex h-full items-start gap-3 rounded-2xl border border-sand bg-white p-6 shadow-card" data-id="element-82" data-mp="nkbm0ihkmau6">
                <CheckCircle2Icon className="mt-0.5 h-6 w-6 shrink-0 text-coral" data-id="element-83" data-mp="1gb3cr0fva7a4" />
                <p className="text-sm leading-relaxed text-ink/80" data-id="element-84" data-mp="1g8z9mkpslcaw">{item}</p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}